/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _EnterpriseColumnLayout = _interopRequireDefault(require("../../EnterpriseColumnLayout"));
var _maybeAddRowReorderColumn = _interopRequireDefault(require("./maybeAddRowReorderColumn"));
var _default = {
  name: 'row-reorder',
  maybeAddColumns: _maybeAddRowReorderColumn.default,
  defaultProps: function defaultProps() {
    return {
      ColumnLayout: _EnterpriseColumnLayout.default
    };
  }
};
exports.default = _default;